<template>
  <v-flex>
    <layout-no-padding>
      <transition name="fadeToggle" mode="out-in">
        <v-flex>
          <v-card class="text-xs-right">
            <v-container fluid>
              <v-layout row wrap class="vertical-center-container">
                <v-flex xs12>
                  <v-spacer></v-spacer>
                  <v-menu
                    bottom
                    left
                    transition="scale-transition"
                    max-height="600px"
                    origin="top right"
                    :close-on-content-click="false"
                    v-model="fieldChooserMenu"
                  >
                    <v-btn flat icon color="grey" slot="activator">
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                        <v-list-tile-action>
                          <v-checkbox
                            :color="$store.state.global.pages.rate.color"
                            v-model="defaultHeaders"
                            :label="header.text"
                            :value="header.value"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
            <v-data-table
              :items="filteredRates"
              :headers="headers"
              :rows-per-page-items="pageOptions"
              v-model="selected"
              select-all
              :search="filterBy"
              :loading="loading"
              disable-initial-sort
            >
              <template slot="no-data">
                <div
                  class="text-xs-center grey--text subheading"
                >No rates for the selected criteria.</div>
              </template>
              <template slot="items" slot-scope="props">
                <rate-row
                  :rate="props.item"
                  :value="props.selected"
                  :headers="headers"
                  @input="toggleSelected"
                  :key="props.item.id"
                ></rate-row>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </transition>
    </layout-no-padding>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import EditRate from "@/components/rates/editRate";

import RateCard from "@/components/rates/rateCard";
import DataListTile from "@/components/ui/dataListTile";

import RateViewMixin from "@/components/rates/rateViewMixin";
import HeaderFilters from "@/services/mixins/headerFilters";
import RateRow from "@/components/rates/rateRow";
//import MultiTripActions from '@/components/trips/actions/multiTripActions';
//import TripViewMixin from '@/components/trips/tripViewMixin'
//import HeaderFilters from '@/services/mixins/headerFilters'

export default {
  mixins: [HeaderFilters, RateViewMixin],
  data() {
    return {
      color: "blue",
      showRate: false,
      activeRateId: "",
      // deleteDialog: false,
      loading: false,
      pageOptions: [
        10,
        20,
        40,
        200,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      fieldChooserMenu: false
    };
  },
  methods: {
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object);
      } else {
        var index = this.selected.indexOf(val.object);
        this.selected.splice(index, 1);
      }
    },
    confirmDelete(rate) {
      this.activeRateId = rate.id;
      //this.deleteDialog = true;
    },

    getRates() {
      var payload = {
        projectId: this.projectId,
        showClosed: this.showInactive
      };

      this.getRatesBy(payload);
    },
    getRatesBy(payload) {
      this.loading = true;
      RateService.getRates(payload)
        .then(result => {
          this.rates = result.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          this.loading = false;
        });
    },
    // getAllRates() {
    //     this.loading = true;
    //     RateService.getRates(payload).then(result => {
    //         //console.log(result);
    //         this.rates = result.data.result;
    //         this.loading = false;
    //         this.$store.commit("rates/setState", { prop: "loadingRates", value: false });
    //     }).catch(err => {
    //         this.$store.commit("rates/setState", { prop: "loadingRates", value: false });
    //         // this.$store.commit("rates/modifyLoadingRates", false);
    //         this.loading = false;
    //         this.snackError();
    //         console.log(err);
    //     });
    // },
    openRate(rate) {
      this.activeRateId = rate.id;
      this.showRate = true;
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "rates", prop: "sortBy" }),
    selected: Store.getSet({ store: "rates", prop: "selected" }),
    filterBy: Store.getSet({ store: "rates", prop: "filterBy" }),
    listView: Store.getSet({ store: "rates", prop: "listView" }),
    rates: Store.getSet({ store: "rates", prop: "rates" }),
    project: Store.getSet({ store: "rates", prop: "project" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    site: Store.getSet({ store: "rates", prop: "site" }),
    showInactive: Store.getSet({ store: "shared", prop: "showInactive" }),

    activeRate() {
      return this.rates.filter(rate => {
        return rate.id == this.activeRateId;
      })[0];
    },
    //project: Store.getSet({store: 'rates', prop: 'project'}),
    siteFilteredRates() {
      if (!!this.site) {
        return this.rates.filter(rate => {
          // //console.log(rate.id);
          // //console.log(project.id);
          return rate.siteId == this.site;
        });
      } else {
        return this.rates;
      }
    },
    sortedRates() {
      if (this.sortBy) {
        var path = this.sortBy;
        return this.siteFilteredRates.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == "updatedAt") {
              return 1;
            }
            return -1;
          } else {
            if (path == "updatedAt") {
              return -1;
            }
            return 1;
          }
        });
      } else {
        return this.siteFilteredRates;
      }
    },
    filteredRates() {
      return this.siteFilteredRates;
      //.filter(rate => {
      //    return rate.site
      //.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
      //});
      //return this.sortedRates;
    }
  },
  components: {
    RateCard,
    //DataListTile,
    EditRate,
    RateRow
  },
  mounted() {
    this.getRates();
  },
  watch: {
    projectId(val) {
      this.getRates();
    },
    showInactive(val) {
      this.getRates();
    }
  }
};
</script>

<style scoped>
.card-list-item {
  transition: all 0.4s;
  /* margin-right: 10px; */
  display: inline-block;
  /* width:100%; */
}
.card-list-enter, .card-list-leave-to
        /* .card-list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-200px);
}
.card-list-leave-active {
  position: absolute;
}

.data-list-item {
  transition: all 0.4s;
  /* margin-right: 10px; */
  display: inline-block;
  width: 100%;
}
.data-list-enter, .data-list-leave-to
        /* .data-list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-200px);
}
.data-list-leave-active {
  position: absolute;
}
</style>
